import {
	INITIAL_DISCOUNT_DATA,
	CUSTOMER_LIST
} from '../actions/types';

const initialState = {
	data: {},
	customers: [],
	customerGroup: [],
};

export default (state = initialState, action) => {
	const payload = action.payload;
	switch (action.type) {
		case INITIAL_DISCOUNT_DATA: {
			let newState = { ...state };
			newState.data = { ...payload.data };
			return newState;
		}
		case CUSTOMER_LIST: {
			let newState = { ...state };
			newState.customers = { ...payload.data };
			return newState;
		}
		default:
			return state;
	}
};
